var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3H19C20.7 3 22 4.3 22 6V20C22 21.7 20.7 23 19 23H5C3.3 23 2 21.7 2 20V6C2 4.3 3.3 3 5 3H7V2C7 1.4 7.4 1 8 1C8.6 1 9 1.4 9 2V3H15V2C15 1.4 15.4 1 16 1C16.6 1 17 1.4 17 2V3ZM7 5H5C4.4 5 4 5.4 4 6V9H20V6C20 5.4 19.6 5 19 5H17V6C17 6.6 16.6 7 16 7C15.4 7 15 6.6 15 6V5H9V6C9 6.6 8.6 7 8 7C7.4 7 7 6.6 7 6V5ZM5 21H19C19.6 21 20 20.6 20 20V11H4V20C4 20.6 4.4 21 5 21Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconCalendar.4bc2567878b42e11c42731151637040b.svg";